import classes from './index.module.css';

export const ShowHideWrapper = ({ isShow, children }) => {
  if (isShow) {
    return children;
  }
  return <div className={classes.hide}>{children}</div>;
};
